import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Wellness translations (always needed — wellness is the primary app)
import wellnessEn from '@/features/wellness/locales/en.json';
import wellnessEs from '@/features/wellness/locales/es.json';

// Common translations for shared components
const commonEn = {
  participants: {
    addParticipants: {
      manual: {
        form: {
          firstName: { label: 'First Name', placeholder: 'Enter first name' },
          middleName: { label: 'Middle Name', placeholder: 'Enter middle name (optional)' },
          lastName: { label: 'Last Name', placeholder: 'Enter last name' },
          gender: {
            label: 'Gender',
            placeholder: 'Select gender',
            options: { male: 'Male', female: 'Female' }
          },
          grade: { label: 'Grade', placeholder: 'Select grade' },
          studentId: { label: 'Student ID', placeholder: 'Enter student ID' },
          birthDate: { label: 'Date of Birth', placeholder: 'Select date' },
          participantEmail: { label: 'Email', placeholder: 'Enter email address' },
          parentEmail: { label: 'Parent/Guardian Email', placeholder: 'Enter parent email' },
        }
      }
    }
  }
};

const commonEs = {
  participants: {
    addParticipants: {
      manual: {
        form: {
          firstName: { label: 'Nombre', placeholder: 'Ingrese el nombre' },
          middleName: { label: 'Segundo Nombre', placeholder: 'Ingrese el segundo nombre (opcional)' },
          lastName: { label: 'Apellido', placeholder: 'Ingrese el apellido' },
          gender: {
            label: 'Género',
            placeholder: 'Seleccione género',
            options: { male: 'Masculino', female: 'Femenino' }
          },
          grade: { label: 'Grado', placeholder: 'Seleccione grado' },
          studentId: { label: 'ID de Estudiante', placeholder: 'Ingrese ID de estudiante' },
          birthDate: { label: 'Fecha de Nacimiento', placeholder: 'Seleccione fecha' },
          participantEmail: { label: 'Correo Electrónico', placeholder: 'Ingrese correo electrónico' },
          parentEmail: { label: 'Correo del Padre/Tutor', placeholder: 'Ingrese correo del padre' },
        }
      }
    }
  }
};

// Survey translations (participantSurveyContent, participantSurveyQuestions) are NOT
// loaded here. They are registered by SurveyRoutes.tsx when the /survey/* chunk loads,
// keeping ~500 kB of JSON out of the initial bundle.
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        wellness: wellnessEn,
        participants: commonEn.participants,
      },
      'en-adult': {
        wellness: wellnessEn,
        participants: commonEn.participants,
      },
      es: {
        wellness: wellnessEs,
        participants: commonEs.participants,
      },
    },
    lng: 'en',
    fallbackLng: ['en'],
    ns: ['wellness', 'participants', 'participantSurveyContent', 'participantSurveyQuestions'],
    defaultNS: 'wellness',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
